// Import styles - this will be separated in webpack by default
import 'normalize.css';
import '../sass/style.scss';
import './components/accordion';
import './components/archive-hero';
import './components/sliders';
import './components/information-bar';
import './components/single-product';
import './components/quantity';
import './components/checkout';
import './components/sticky-menu';
import './components/anchor-links';
import './modules/newsletter';
import './components/auctions';
import MiniCart from './components/mini-cart';
import './ac-mobile-menu';

// Components
const miniCart = document.querySelector( '.widget_shopping_cart' );
if ( miniCart ) {
	new MiniCart();
}
jQuery( $ => {
	$( '[data-search-toggle]' ).on( 'click', function() {
		$( this ).toggleClass( 'search-open' );

		$( this ).attr( 'aria-expanded', ( i, attr ) => {
			return 'true' === attr ? 'false' : 'true';
		} );

		$( '#search-container' ).slideToggle( 150, function() {
			$( this ).find( '.form-control' ).focus();
		} );
	} );

	/**
	 * Generic back button functionality.
	 */
	$( '.js-back-button' ).on( 'click', e => {
		e.preventDefault();
		// Equal to clicking the back button in the browser.
		window.history.back();
	} );
} );

jQuery( function( $ ) {
	// Maint/2111 AMSU-127 - HACK to fix infobox
	const desc = $( '.aelia_wc_eu_vat_assistant.vat_number .woocommerce-input-wrapper :input' ).parent().find( 'span.description' );
	if ( desc ) {
		desc.css( 'display', 'none' );
	}
} );
